import React from "react";
import styled from "styled-components";
import client1 from "../assets/client1.png";
import client2 from "../assets/client2.png";
import client3 from "../assets/client3.png";

export default function Clients() {
  const clients = [client1, client2, client3];
  return (
    <Section>
      {clients.map((client, index) => {
        return (
          <div className="client" key={index}>
            <img src={client} alt="client" />
          </div>
        );
      })}
    </Section>
  );
}
const Section = styled.section`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin: 0 2rem;
  margin-bottom: 5rem;
`;
